/**
 * reCAPTCHA v3 トークン取得 (mfk-purchase-subsystem P3 非機能・公開フロー保護)
 * VITE_RECAPTCHA_SITE_KEY 未設定なら undefined を返す(=バックエンドは検証スキップ)。
 * 設定時のみスクリプトを遅延ロードし、送信時にトークンを取得する。
 */
const SITE_KEY = import.meta.env.VITE_RECAPTCHA_SITE_KEY as string | undefined;
let loading: Promise<void> | null = null;

declare global {
  interface Window {
    grecaptcha?: { ready: (cb: () => void) => void; execute: (key: string, opts: { action: string }) => Promise<string> };
  }
}

function loadScript(): Promise<void> {
  if (!SITE_KEY) return Promise.resolve();
  if (loading) return loading;
  loading = new Promise<void>((resolve) => {
    if (window.grecaptcha) return resolve();
    const s = document.createElement('script');
    s.src = `https://www.google.com/recaptcha/api.js?render=${SITE_KEY}`;
    s.async = true;
    s.onload = () => resolve();
    s.onerror = () => resolve(); // 失敗してもフローは止めない(バックエンドは fail-open)
    document.head.appendChild(s);
  });
  return loading;
}

export async function getRecaptchaToken(action = 'purchase'): Promise<string | undefined> {
  if (!SITE_KEY) return undefined;
  try {
    await loadScript();
    if (!window.grecaptcha) return undefined;
    return await new Promise<string | undefined>((resolve) => {
      window.grecaptcha!.ready(() => {
        window.grecaptcha!.execute(SITE_KEY, { action }).then(resolve).catch(() => resolve(undefined));
      });
    });
  } catch {
    return undefined;
  }
}
